export default __webpack_public_path__ + "static/media/rob-no.2a13f1a6.png";